import React from 'react';
import {
  Create,
  TextInput,
  SimpleForm,
  ImageField,
  ImageInput,
  NumberInput,
  maxLength,
  required,
  useNotify,
  useRedirect,
} from "react-admin";

export const CreateSeller = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data) => {
    notify("Vendedor creado exitosamente", {
      type: "info",
      messageArgs: { smart_count: 1, name: data.name },
    });
    redirect("list", props.basePath || "/sellers", data.id, data);
  };

  return (
    <Create {...props} mutationOptions={{ onSuccess }}>
      <SimpleForm
      // redirect="list" // Controlado por onSuccess
      >
        <TextInput
          source="name"
          label="Nombre"
          validate={[required(), maxLength(200)]}
        />
        <TextInput
          source="webSite"
          label="Sitio Web"
          validate={[required(), maxLength(200)]}
        />
        <NumberInput source="position" label="Orden" validate={[required()]} />
        <ImageInput
          validate={[required()]}
          source="image"
          label="*"
          accept="image/*"
          placeholder={<p>Click aquí o arrastre y suelte las imágenes</p>}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create>
  );
};
